import { Stack, Typography } from "@mui/material";
import moment from "moment-timezone";
import { APP_COLORS } from "../../../../enums";
import { DateBadgeProps } from "./types";

export function DateBadge({ dateKey }: DateBadgeProps) {
  const date = moment(dateKey);
  const isToday = date.isSame(moment(), "day");

  return (
    <Stack alignItems="center" gap={0.25} minWidth={52}>
      <Stack
        alignItems="center"
        justifyContent="center"
        gap={0.125}
        width={52}
        height={56}
        borderRadius={1.5}
        border={`1px solid ${isToday ? APP_COLORS.primary : APP_COLORS.greyLight6}`}
      >
        <Typography
          variant="caption"
          color={isToday ? "primary" : "text.secondary"}
          fontWeight={700}
          lineHeight={1}
          sx={{ letterSpacing: 0.6, fontSize: 9 }}
        >
          {date.format("ddd").toUpperCase()}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={700}
          lineHeight={1}
          color={isToday ? "primary" : "text.primary"}
        >
          {date.format("D")}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          lineHeight={1}
          fontSize={9}
        >
          {date.format("MMM")}
        </Typography>
      </Stack>
      {isToday && (
        <Typography variant="caption" color="primary" fontWeight={700} fontSize={9}>
          Today
        </Typography>
      )}
    </Stack>
  );
}
